import api from '../api';
import { Angel, PaginationParams, PaginationResponse } from '../../types';

interface AngelListParams extends PaginationParams {
  status?: string;
  verified?: string;
}

interface AngelListResponse {
  angels: Angel[];
  pagination: PaginationResponse;
}

export const angelService = {
  async getAll(params?: AngelListParams): Promise<AngelListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.verified) queryParams.append('verified', params.verified);
    
    const response = await api.get(`/admin/angels?${queryParams.toString()}`);
    return response.data;
  },

  async getById(id: string): Promise<Angel> {
    const response = await api.get(`/admin/angels/${id}`);
    return response.data;
  },

  async verify(id: string, verified: boolean): Promise<Angel> {
    const response = await api.put(`/admin/angels/${id}/verify`, { verified });
    return response.data;
  },

  async updateStatus(id: string, isActive: boolean): Promise<Angel> {
    const response = await api.put(`/admin/angels/${id}/status`, { isActive });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/angels/${id}`);
  },
};
